import * as request from "request";
import {baseUrl, googleLoginVersion} from "config";

import * as qs from "querystring";
import {tokenUtility} from "utils/secure";

let authExternal = false;
let authExtToken = null;

export function addAuth(json) {
  const idToken = getIdToken();

  json.facebookToken = idToken;
  return json;
}

(window as any).getToken = () => {
  return getIdToken();
};

(window as any).setWebStyle = (id, value) => {
  return setWebStyle(id, value);
};

export function setWebStyle(id: string, value: string) {
  if (document.getElementById(id)) {
    document.getElementById(id).setAttribute(
        "style", value);
  }
}
export function getIdToken() {
  if (!authExternal) {
    let idToken = null;
    const g: any = (window as any).gapi;
    if (g && g.auth2 && g.auth2.getAuthInstance().currentUser.get().getAuthResponse().id_token) {
      idToken = g.auth2.getAuthInstance().currentUser.get().getAuthResponse().id_token;
    }
    if (tokenUtility().getStoredToken()) {
      idToken = tokenUtility().getStoredToken();
    }
    return idToken;
  } else {
    return authExtToken;
  }
}

export function headers() {
  const idToken = getIdToken();
  return {Authorization: `Bearer ${idToken}`};
}

export function setAuthentication(token) {
  authExternal = true;
  authExtToken = token;
}

export function resetAuth() {
  authExternal = false;
}

function endPointUrl(url) {
  let path = url;
  if (typeof url === "object") {
    const query = url.qs || {};
    const queryString = qs.stringify(query);
    path = queryString ? (`${url.url}?${queryString}`) : url.url;
  }
  return `${baseUrl}${path}`;
}
export function getAuthExternalStatus() {
    return authExternal;
}
export function changeAuthExternalStatus() {
  authExternal = false;
}
export function rGet(url, cb) {
  const uri = endPointUrl(url);
  return request({
    method: "GET",
    uri,
    headers: headers(),
    json: {},
  }, cb);
}

export function rPost(url, options: any = {}, cb) {
  let callback = cb;
  let payload;

  if (typeof options === "function") {
    callback = options;
    payload = {};
  }

  if (typeof options === "object") {
    payload = options.data || {};
    if (options.addAuth) {
      payload = addAuth(payload);
    }
  }

  const uri = endPointUrl(url);
  return request({
    method: "POST",
    uri,
    headers: headers(),
    json: payload,
  }, callback);
}
